export const RESET_DIALOG_CONFIGURATION = Object.freeze({
  PROMPT: {
    title: 'Do you want to reset your syllabus?',
    cssClass: 'text-center',
    buttons: [{
      title: 'Reset'
    }],
    message: `
    <p>
      You are about to <strong>ERASE ALL</strong> task completion progress on this syllabus.
      <br>Exam and Question Bank data will not be affected.
    </p>
    <p>
      <strong>THIS ACTION CANNOT BE UNDONE</strong>
    </p>
    `
  },
  SUCCESS: {
    title: 'Success!',
    message: `
    <p>
      Your syllabus has been reset.
    </p>
    `,
    dismissButtonTitle: 'Close'
  }
})



// WEBPACK FOOTER //
// ./src/app/workspace/path-reset-dialog/reset-dialog.configuration.ts